module.exports = __webpack_public_path__ + "img/Airbnb-landing-Page-Working-From-Listing-1-1.adb0ccf1.jpg";